import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';
import { Popup } from '../Global/Popup';
import Cookies from 'universal-cookie';

const Confim = (props) => {

    const [data, setData] = useState({
        fName: '',
        lName: '',
        nationalCode: '',
        birthdatDate: '',
        province: '',
        provinceId: '',
        city: '',
        cityId: '',
        nameShop: '',
        nameShopId: '',
        manager: ''
    })
    const [state, setState] = useState({
        loading: false,
        dateValue: null,
        loader: false,
        statusDisAccount: false,
        tokenUser: ''
    })

    useEffect(() => {

        const infoPerson = JSON.parse(localStorage.getItem('personalInfo'))
        const infoShop = JSON.parse(localStorage.getItem('shopInfo'))

        setData({
            fName: infoPerson.firstName,
            lName: infoPerson.lastName,
            nationalCode: infoPerson.nationalCode,
            birthdatDate: infoPerson.dateBirthday,
            province: infoShop.provinceTitle,
            provinceId: infoShop.provinceId,
            city: infoShop.cityTitle,
            cityId: infoShop.cityId,
            nameShop: infoShop.shopTitle,
            nameShopId: infoShop.shopId,
            manager: infoShop.manager
        })

        setTimeout(() => {
            setState({
                ...state,
                loading: true
            })
        }, 300);
    }, [])

    const contniue = () => {

        setState({
            ...state,
            loader: true,
        })
        const Data = {
            'mobile': JSON.parse(localStorage.getItem('phoneNumber')),
            'code': JSON.parse(localStorage.getItem('verfCode')),
            'name': data.fName,
            'last_name': data.lName,
            'national_code': data.nationalCode,
            'birthdate': data.birthdatDate,
            'store_id': data.nameShopId,
            'is_manager': data.manager ? 1 : 0,
            'webpush_id': localStorage.getItem('gcm_id')
        }
      
        base_url.post("fillprofile", Data)
            .then(response => {
                setState({
                    ...state,
                    loader: false,
                    statusDisAccount: true,
                    tokenUser: response.data.token
                })
            })
    }

    const confirmAccount = () => {
        setState({
            ...state,
            statusDisAccount: false
        })
        const cookies = new Cookies()
        cookies.set("api_key", state.tokenUser, {
            maxAge: 604800,
            path: "/",
        })
        props.history.push('/')
        window.location.reload()
    }

    return (
        <div className={`entrnc-base pesronal-info confirm-info ${state.loading ? 'active' : ''}`}>
            <Loader
                active={state.loader} />
            <Popup
                active={state.statusDisAccount}
                classes="popup-accountreg" >
                <div className="disable-account">
                    <h4>ثبت نام شما با موفقیت انجام شد بعد از تایید ادمین حساب شما فعال خواهد شد.</h4>
                    <div className="btn-base btn-black btn-sircle">
                        <Button
                            variant="contained"
                            onClick={confirmAccount} >تایید</Button>
                    </div>
                </div>
            </Popup>
            <div className="titles-base titles-style-2">
                <h4>
                    <Link to="/Entrance/step4">
                        <i className="icon-arrow-down-sign-to-navigate"></i>
                    </Link>
                    اطلاعات شخصی
                </h4>
                <div className="step-progress">
                    <span className="active"></span>
                    <span className="active"></span>
                    <span className="active"></span>
                </div>
            </div>

            <div className="bx-info">
                <div className="card-info">
                    <div className="row-card">
                        <span>اطلاعات شخصی </span>
                        <Link to="/Entrance/step3"><i className="icon-edit"></i></Link>
                    </div>
                    <div className="row-card">
                        <div className="item-card">
                            <span>نام</span>
                            <strong>{data.fName}</strong>
                        </div>
                        <div className="item-card">
                            <span>نام خانوادگی</span>
                            <strong>{data.lName}</strong>
                        </div>
                    </div>
                    <div className="row-card">
                        <div className="item-card">
                            <span>کد ملی</span>
                            <strong>{data.nationalCode}</strong>
                        </div>
                        <div className="item-card">
                            <span>تاریخ تولد</span>
                            <strong>{data.birthdatDate}</strong>
                        </div>
                    </div>
                </div>
                <div className="card-info">
                    <div className="row-card">
                        <span>اطلاعات فروشگاه </span>
                        <Link to="/Entrance/step4"><i className="icon-edit"></i></Link>
                    </div>
                    <div className="row-card">
                        <div className="item-card">
                            <span>استان</span>
                            <strong>{data.province}</strong>
                        </div>
                        <div className="item-card">
                            <span>شهر</span>
                            <strong>{data.city}</strong>
                        </div>
                    </div>
                    <div className="row-card">
                        <div className="item-card">
                            <span>نام فروشگاه</span>
                            <strong>{data.nameShop}</strong>
                        </div>
                        <div className="item-card">
                            <span>مدیر فروشگاه هستم</span>
                            <strong>
                                {
                                    data.manager ?
                                        'بلی'
                                        :
                                        'خیر'
                                }
                            </strong>
                        </div>
                    </div>
                </div>
                <div className="btn-base btn-black btn-sircle">
                    <Button
                        variant="contained"
                        onClick={contniue}>تایید و ثبت نام</Button>
                </div>
            </div>

        </div >
    );
}

export default Confim;